export default {
  geo: {
      data: [],
      settings: {
          legend: {
              layout: 'horizontal'
          },
          title: 'countries'
      }
  },
  demography: {
    data: [],
    settings: {
        legend: {
            layout: 'vertical'
        },
        title: 'gender-age'
    }
  },
  sources: {
    data: [],
    settings: {
        legend: {
            layout: 'vertical'
        },
        title: 'sources'
    }
  },
};